import dom from "../../../dist/jsx-render/dom"
import JSXComponent from "../../../dist/jsx-render/JSXComponent"

export class WaitPanelComponent extends JSXComponent {
    props: {
    }

    element: HTMLElement =
        <div className="text-center">
            <div className="mt-1 mb-1">
                Loading...
            </div>
            <div className="spinner-border mb-1">
            </div>
        </div>

    render() {
        return this.element;
    }
}
